import React from 'react';
import ModuleRoute from 'holocron-module-route';
import { ExperimentProvider as OneXpWrapper } from '@americanexpress/one-xp-client-sdk';
import {
  DLS7Wrapper, DLSScript, DLSWrapper, PreloadbleFontsWrapper,
} from './components/StyleLoader';
import AnalyticsWrapper from './components/AnalyticsWrapper';
import BasicError from './components/Errors/BasicError';
import ErrorLayout from './components/Errors/ErrorLayout';
import GlobalNavigationWrapper from './components/GlobalNavigationWrapper';
import UsConsumerSharedScripts from './components/UsConsumerSharedScripts';
import LegacyOneXPWrapper from './components/LegacyOneXPWrapper';
import setActiveLocale from './utils/setActiveLocale';
import redirectToUsRoute from './utils/redirectToUsRoute';
import GtagLocaleWrapper from './components/GtagLocaleWrapper';

const childRoutes = (store) => (
  <ModuleRoute>
    <ModuleRoute component={AnalyticsWrapper}>
      {/* INTL COMMERCIAL */}
      <ModuleRoute component={GlobalNavigationWrapper}>
        <ModuleRoute component={DLSWrapper}>
          {/* INTL LEAD GEN */}
          <ModuleRoute
            onEnter={setActiveLocale(store)}
            path="/:locale/business/form/:productName"
            moduleName="acq-shop-lead-generation"
          />
        </ModuleRoute>
        {/* Mexico Shop3 - Corp VAC */}
        <ModuleRoute path="es-mx" onEnter={setActiveLocale(store, 'es-MX')}>
          <ModuleRoute
            path="negocios/tarjetas-corporativas/"
            moduleName="axp-shop-international-commercial-view-all-cards"
            locale="es-mx"
            shopType="corporate"
            pageName="vac"
          />
          {/* Mexico Shop3 - Corp PDP */}
          <ModuleRoute
            path="negocios/tarjetas-corporativas/:pageName/"
            moduleName="axp-shop-international-commercial-card-details"
            locale="es-mx"
            shopType="corporate"
          />
          {/* Mexico - SBS PDP */}
          <ModuleRoute
            path="negocios/tarjetas/:pageName/"
            moduleName="axp-shop-international-commercial-card-details"
            locale="es-mx"
            shopType="business"
          />
        </ModuleRoute>
        {/* Canada EN VAC - SBS */}
        <ModuleRoute path="en-ca" onEnter={setActiveLocale(store, 'en-CA')}>
          <ModuleRoute
            path="business/credit-cards/"
            moduleName="axp-shop-international-commercial-view-all-cards"
            locale="en-ca"
            shopType="business"
            pageName="vac"
          />
          {/* Canada EN PDP - SBS */}
          <ModuleRoute
            path="business/credit-cards/:pageName/"
            moduleName="axp-shop-international-commercial-card-details"
            locale="en-ca"
            shopType="business"
          />
          {/* Canada EN VAC - Corp */}
          <ModuleRoute
            path="business/corporate-credit-cards/"
            moduleName="axp-shop-international-commercial-view-all-cards"
            locale="en-ca"
            shopType="corporate"
            pageName="vac"
          />
          {/* Canada EN PDP - Corp */}
          <ModuleRoute
            path="business/corporate-credit-cards/:pageName/"
            moduleName="axp-shop-international-commercial-card-details"
            locale="en-ca"
            shopType="corporate"
          />
        </ModuleRoute>

        {/* Canada FR VAC - SBS */}
        <ModuleRoute path="fr-ca" onEnter={setActiveLocale(store, 'fr-CA')}>
          <ModuleRoute
            path="entreprise/cartes-de-credit/"
            moduleName="axp-shop-international-commercial-view-all-cards"
            locale="fr-ca"
            shopType="business"
            pageName="vac"
          />
          {/* Canada FR PDP - SBS */}
          <ModuleRoute
            path="entreprise/cartes-de-credit/:pageName/"
            moduleName="axp-shop-international-commercial-card-details"
            locale="fr-ca"
            shopType="business"
          />
          {/* Canada FR VAC - Corp */}
          <ModuleRoute
            path="entreprise/cartes-de-credit-pour-entreprises/"
            moduleName="axp-shop-international-commercial-view-all-cards"
            locale="fr-ca"
            shopType="corporate"
            pageName="vac"
          />
          {/* Canada FR PDP - Corp */}
          <ModuleRoute
            path="entreprise/cartes-de-credit-pour-entreprises/:pageName/"
            moduleName="axp-shop-international-commercial-card-details"
            locale="fr-ca"
            shopType="corporate"
          />
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>
    {/* INTL Consumer */}
    {/* Routes with page view analytics event disabled */}
    <ModuleRoute shouldDisablePageView={true} component={AnalyticsWrapper}>
      <ModuleRoute component={GlobalNavigationWrapper}>
        <ModuleRoute component={LegacyOneXPWrapper}>
          <ModuleRoute path="en-gb" onEnter={setActiveLocale(store, 'en-GB')}>
            {/* UK EC Routes */}
            <ModuleRoute path="credit-cards/eligibility-checker">
              <ModuleRoute
                path="form-page"
                moduleName="axp-apply-eligibility-checker-forms"
                locale="en-GB"
              />
              <ModuleRoute
                path="result-page"
                moduleName="axp-shop-eligibility-checker-results"
                locale="en-GB"
              />
            </ModuleRoute>
          </ModuleRoute>
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>
    <ModuleRoute component={AnalyticsWrapper}>
      <ModuleRoute component={GtagLocaleWrapper}>
        <ModuleRoute component={GlobalNavigationWrapper}>
          {/* EN-GB: UK */}
          <ModuleRoute component={LegacyOneXPWrapper}>
            <ModuleRoute path="en-gb" onEnter={setActiveLocale(store, 'en-GB')}>
              {/* International MCLP Pages */}
              <ModuleRoute
                path="credit-cards/compare/:pageName"
                moduleName="axp-international-shop-multi-cards"
                locale="en-GB"
              />
              <ModuleRoute
                path="charge-cards/compare/:pageName"
                moduleName="axp-international-shop-multi-cards"
                locale="en-GB"
              />
              {/* UK Routes */}
              <ModuleRoute
                path="credit-cards/all-cards/:cardFilter"
                moduleName="axp-shop-ombrello-uk-consumer-view-all-cards"
                locale="en-GB"
              />
              <ModuleRoute
                path="credit-cards/all-cards"
                moduleName="axp-shop-ombrello-uk-consumer-view-all-cards"
                locale="en-GB"
              />
              <ModuleRoute
                path="credit-cards/:cardslug"
                moduleName="axp-shop-ombrello-uk-consumer-card-details"
                locale="en-GB"
              />
              <ModuleRoute
                path="charge-cards/:cardslug"
                moduleName="axp-shop-ombrello-uk-consumer-card-details"
                locale="en-GB"
              />
            </ModuleRoute>

            {/* New EN AU Routes */}
            <ModuleRoute path="en-au" onEnter={setActiveLocale(store, 'en-AU')}>
              <ModuleRoute
                path="credit-cards/:cardSlug/:cardFilter/:cardSubFilter"
                moduleName="axp-shop-ombrello-au-consumer-view-all-cards"
                locale="au_en"
              />
              <ModuleRoute
                path="credit-cards/all-cards/:cardFilter"
                moduleName="axp-shop-ombrello-au-consumer-view-all-cards"
                locale="au_en"
              />
              <ModuleRoute
                path="credit-cards/all-cards"
                moduleName="axp-shop-ombrello-au-consumer-view-all-cards"
                locale="au_en"
              />
              <ModuleRoute
                path="credit-cards/:cardslug"
                moduleName="axp-shop-ombrello-au-consumer-card-details"
                locale="au_en"
              />
              <ModuleRoute
                path="credit-cards/compare/:pageName"
                moduleName="axp-international-shop-multi-cards"
                locale="en-au"
              />
            </ModuleRoute>

            {/* MX Routes */}
            <ModuleRoute path="mx" onEnter={setActiveLocale(store, 'es-MX')}>
              <ModuleRoute
                path="tarjetas-de-credito/nuestras-tarjetas"
                moduleName="axp-shop-ombrello-mx-consumer-view-all-cards"
                locale="es-mx"
              />
              <ModuleRoute
                path="tarjetas-de-credito/:cardslug"
                moduleName="axp-shop-ombrello-mx-consumer-card-details"
                locale="es-mx"
              />
              <ModuleRoute
                path="tarjetas-de-servicio/:cardslug"
                moduleName="axp-shop-ombrello-mx-consumer-card-details"
                locale="es-mx"
              />
            </ModuleRoute>
            <ModuleRoute path="es-mx" onEnter={setActiveLocale(store, 'es-MX')}>
              <ModuleRoute
                path="tarjetas-de-credito/nuestras-tarjetas"
                moduleName="axp-shop-ombrello-mx-consumer-view-all-cards"
                locale="es-mx"
              />
              <ModuleRoute
                path="tarjetas-de-credito/:cardslug"
                moduleName="axp-shop-ombrello-mx-consumer-card-details"
                locale="es-mx"
              />
              <ModuleRoute
                path="tarjetas-de-servicio/:cardslug"
                moduleName="axp-shop-ombrello-mx-consumer-card-details"
                locale="es-mx"
              />
            </ModuleRoute>
            {/* JP Routes */}
            <ModuleRoute path="jp" onEnter={setActiveLocale(store, 'ja-JP')}>
              {/* International MCLP Pages */}
              <ModuleRoute
                path="credit-cards/compare/:pageName"
                moduleName="axp-international-shop-multi-cards"
                locale="ja-jp"
              />
              <ModuleRoute
                path="credit-cards/all-cards/:cardFilter"
                moduleName="axp-shop-ombrello-jp-consumer-view-all-cards"
                locale="ja-jp"
              />
              <ModuleRoute
                path="credit-cards/all-cards"
                moduleName="axp-shop-ombrello-jp-consumer-view-all-cards"
                locale="ja-jp"
              />
              <ModuleRoute
                path="credit-cards/:cardslug"
                moduleName="axp-shop-ombrello-jp-consumer-card-details"
                locale="ja-jp"
              />
            </ModuleRoute>
            <ModuleRoute path="ja-jp" onEnter={setActiveLocale(store, 'ja-JP')}>
              <ModuleRoute
                path="credit-cards/compare/:pageName"
                moduleName="axp-international-shop-multi-cards"
                locale="ja-jp"
              />
              <ModuleRoute
                path="credit-cards/all-cards/:cardFilter"
                moduleName="axp-shop-ombrello-jp-consumer-view-all-cards"
                locale="ja-jp"
              />
              <ModuleRoute
                path="credit-cards/all-cards"
                moduleName="axp-shop-ombrello-jp-consumer-view-all-cards"
                locale="ja-jp"
              />
              <ModuleRoute
                path="credit-cards/:cardslug"
                moduleName="axp-shop-ombrello-jp-consumer-card-details"
                locale="ja-jp"
              />
            </ModuleRoute>
            {/* CA Routes */}
            <ModuleRoute path="en-ca" onEnter={setActiveLocale(store, 'en-CA')}>
              <ModuleRoute
                path="credit-cards/all-cards"
                moduleName="axp-international-shop-view-all-cards"
                locale="en-ca"
              />
              <ModuleRoute
                path="credit-cards/:cardslug"
                moduleName="axp-international-shop-card-details"
                locale="en-ca"
              />
              <ModuleRoute
                path="charge-cards/:cardslug"
                moduleName="axp-international-shop-card-details"
                locale="en-ca"
              />
            </ModuleRoute>
            <ModuleRoute path="fr-ca" onEnter={setActiveLocale(store, 'fr-CA')}>
              <ModuleRoute
                path="cartes-de-credit/toutes-les-cartes"
                moduleName="axp-international-shop-view-all-cards"
                locale="fr-ca"
              />
              <ModuleRoute
                path="cartes-de-credit/:cardslug"
                moduleName="axp-international-shop-card-details"
                locale="fr-ca"
              />
              <ModuleRoute
                path="cartes-de-paiement/:cardslug"
                moduleName="axp-international-shop-card-details"
                locale="fr-ca"
              />
            </ModuleRoute>
          </ModuleRoute>
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>
    {/* COMMERCIAL */}
    <ModuleRoute component={AnalyticsWrapper} onEnter={setActiveLocale(store, 'en-us')}>
      <ModuleRoute component={DLSWrapper}>
        <ModuleRoute component={GlobalNavigationWrapper}>
          {/* BCA */}
          <ModuleRoute
            path="/en-us/business/checking"
            moduleName="axp-shop-business-checking"
            locale="us"
            pageName="business-checking"
            shopType="noncard"
          />
          {/* NONCARD */}
          <ModuleRoute
            path="/us/business/business-funding/business-loans"
            moduleName="acq-shop-non-card"
            pageName="business-funding-business-loans"
            locale="en_us"
          />
          <ModuleRoute
            path="/us/business/business-funding/working-capital-terms"
            moduleName="acq-shop-non-card"
            pageName="business-funding-working-capital-terms"
            locale="en_us"
          />
          <ModuleRoute
            path="/us/business/business-funding/merchant-financing"
            moduleName="acq-shop-non-card"
            pageName="business-funding-merchant-financing"
            locale="en_us"
          />
          <ModuleRoute
            path="/us/business/business-funding"
            moduleName="acq-shop-non-card"
            pageName="business-funding"
            locale="en_us"
          />
          <ModuleRoute
            path="/en-us/business/payment-solutions/vendor-payments"
            moduleName="acq-shop-non-card"
            pageName="payment-solutions-vendor-payments"
            locale="en_us"
          />
          <ModuleRoute
            path="/en-us/business/payment-solutions/employee-spending"
            moduleName="acq-shop-non-card"
            pageName="payment-solutions-employee-spending"
            locale="en_us"
          />
          <ModuleRoute
            path="/en-us/business/payment-solutions"
            moduleName="acq-shop-non-card"
            pageName="payment-solutions"
            locale="en_us"
          />
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>

    {/* CONSUMER */}
    <ModuleRoute onEnter={setActiveLocale(store, 'en-us')}>
      <ModuleRoute component={UsConsumerSharedScripts}>
        <ModuleRoute component={PreloadbleFontsWrapper}>
          <ModuleRoute component={OneXpWrapper}>
            <ModuleRoute component={DLSWrapper}>
              <ModuleRoute component={DLSScript}>
                <ModuleRoute component={AnalyticsWrapper} shouldDisablePageView={true}>
                  <ModuleRoute
                    path="en-us/credit-cards/offers"
                    moduleName="axp-us-consumer-affiliate-partners"
                  />
                </ModuleRoute>
                <ModuleRoute
                  path="en-us/content-editor"
                  moduleName="axp-shop-us-consumer-content-editor"
                />
                <ModuleRoute component={GlobalNavigationWrapper}>
                  <ModuleRoute component={AnalyticsWrapper}>
                    <ModuleRoute
                      path="us/credit-cards/dtw-landing"
                      moduleName="axp-shop-us-consumer-drive-to-web"
                    />
                    <ModuleRoute
                      path="us/credit-cards/dtw-cid"
                      moduleName="axp-shop-us-consumer-drive-to-web"
                    />
                    <ModuleRoute
                      path="us/credit-cards/dtw-transfer-cid"
                      moduleName="axp-shop-us-consumer-drive-to-web"
                    />
                  </ModuleRoute>
                </ModuleRoute>
                <ModuleRoute component={DLS7Wrapper}>
                  <ModuleRoute component={AnalyticsWrapper}>
                    <ModuleRoute path="en-us/banking" moduleName="axp-us-consumer-banking" />
                  </ModuleRoute>
                </ModuleRoute>
              </ModuleRoute>
            </ModuleRoute>
            <ModuleRoute component={DLS7Wrapper}>
              <ModuleRoute component={DLSScript}>
                <ModuleRoute
                  component={AnalyticsWrapper}
                  pageTitle="American Express Credit Cards, Rewards, Travel and Business Services"
                  shouldDisablePageView={true}
                >
                  {/*
                      Need to add specific page paths as we only want to force
                      the locale redirect for these stanford pages without impact
                      to other /credit-card/ pages
                    */}
                  <ModuleRoute
                    path="en-us/credit-cards/offers/featured-cards"
                    moduleName="axp-shop-us-consumer"
                    hasChildRoutes={true}
                    onEnter={redirectToUsRoute}
                  />
                  <ModuleRoute
                    path="en-us/credit-cards/offers/cash-back-cards"
                    moduleName="axp-shop-us-consumer"
                    hasChildRoutes={true}
                    onEnter={redirectToUsRoute}
                  />
                  <ModuleRoute
                    path="en-us/credit-cards/offers/delta-skymiles-cards"
                    moduleName="axp-shop-us-consumer"
                    hasChildRoutes={true}
                    onEnter={redirectToUsRoute}
                  />
                  <ModuleRoute
                    path="en-us/credit-cards/offers/hilton-cards"
                    moduleName="axp-shop-us-consumer"
                    hasChildRoutes={true}
                    onEnter={redirectToUsRoute}
                  />
                  <ModuleRoute path="en-us/credit-cards" moduleName="axp-shop-us-consumer" />
                  <ModuleRoute path="us/credit-cards" moduleName="axp-shop-us-consumer" />
                </ModuleRoute>
              </ModuleRoute>
            </ModuleRoute>
          </ModuleRoute>
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>
    <ModuleRoute component={AnalyticsWrapper}>
      {/* v5 does not come with error handling out of the box; These styles need to revisited. */}
      <ModuleRoute key="error-page-navigation-wrapper" component={GlobalNavigationWrapper}>
        <ModuleRoute key="ErrorLayout" component={ErrorLayout}>
          <ModuleRoute code="500" component={BasicError} path="*/error" header="Load Error" />
          <ModuleRoute code="400" component={BasicError} path="*" header="Page Not Found" />
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>
  </ModuleRoute>
);

export default childRoutes;
